import { Outlet } from "react-router-dom";
import {
  AudioVideoProvider,
  RosterProvider,
  RemoteVideoTileProvider,
  ContentShareProvider,
  NotificationProvider,
  LoggerProvider,
} from "amazon-chime-sdk-component-library-react";
import { meetingConfig } from "../features/video/meetingConfig.ts";
import { Notifications } from "../features/video/containers/Notifications";
import { ChimeFeatureWrappers } from "../features/video/components/ChimeFeatureWrappers";
import { DevicesProvider } from "../features/video/providers/DevicesProvider";
import { VideoTileGridEffects } from "@platform/features/video/components/VideoTileGridEffects";
import { VideoMeetingDialogs } from "../features/videoMeeting/components/VideoMeetingDialogs/VideoMeetingDialogs";
import { TrackingProvider } from "@core/features/tracking";
import { TranscriptionProvider } from "../features/video/providers/TranscriptionProvider";
import { VideoEventListeners } from "../features/video/VideoEventListeners";
import { VideoLayoutCleanup } from "../features/video/components/VideoLayoutCleanup";
import { ChatSessionContainer } from "@platform/features/chat";
import { DashboardNavigationItemsContainer } from "@platform/layouts/DashboardNavigation";
import { DashboardAlertBannerContainer } from "@platform/layouts/DashboardAlertBanner";
import { ChatSheetContainer } from "@platform/features/chat";
import { usePlatformStore } from "@platform/store";
import { AppLayout } from "@platform/layouts/AppLayout";
import { Toast } from "@themes/pollinator/ui/Toast";

export type Props = {
  isWithNavigation?: boolean;
};

export function VideoLayout({ isWithNavigation = false }: Props) {
  const isTranscriptionDisabled = usePlatformStore(
    (s) => s.featureFlags.isTranscriptionDisabled
  );

  return (
    <TrackingProvider
      debug={{ enabled: false }}
      services={{ posthog: true, google_analytics: true }}
    >
      <LoggerProvider logger={meetingConfig.logger}>
          <ChimeFeatureWrappers>
              <NotificationProvider>
                <AudioVideoProvider>
                  <DevicesProvider>
                        <RosterProvider>
                          <TranscriptionProvider
                            isTranscriptionDisabled={
                              isTranscriptionDisabled || false
                            }
                          >
                            <RemoteVideoTileProvider>
                              <ContentShareProvider>
                                <ChatSessionContainer>
                                  <Toast />
                                  <Notifications />
                                  <VideoEventListeners />
                                  <VideoTileGridEffects />
                                  <VideoLayoutCleanup />
                                  {isWithNavigation ? (
                                    <AppLayout
                                      isWithSidebar
                                      sidebar={<DashboardNavigationItemsContainer />}
                                      title="Video"
                                      isWithFooter
                                    >
                                      <DashboardAlertBannerContainer />
                                      <main className="flex flex-col flex-1">
                                        <Outlet />
                                      </main>
                                    </AppLayout>
                                  ) : (
                                    <main className="flex-grow flex flex-col bg-brand-50 h-full min-h-[100dvh]">
                                      <Outlet />
                                    </main>
                                  )}
                                  <VideoMeetingDialogs />
                                  <ChatSheetContainer />
                                </ChatSessionContainer>
                              </ContentShareProvider>
                            </RemoteVideoTileProvider>
                          </TranscriptionProvider>
                        </RosterProvider>
                  </DevicesProvider>
                </AudioVideoProvider>
              </NotificationProvider>
          </ChimeFeatureWrappers>
      </LoggerProvider>
    </TrackingProvider>
  );
}

export default VideoLayout;
